import React, { useEffect, useState } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import {
  DASHBOARD_PATH,
  REQUESTS_PATH,
  DOCUMENTS_PATH,
  USERS_ROUTE_PATH,
  CUSTOMERS_ROUTE_PATH,
  AGENCY_INVOICE_PAGE,
  AGENCY_NEWINVOICE_PAGE,
  AGENCY_CUSTOMER_PAGE,
  AGENCY_SUBSCRIPTIONS_PAGE,
  AGENCY_COUPONS_PAGE,
  AGENCY_REPORT_PAGE,
} from '../../utils/AppRoutes';
import { Link, useLocation } from 'react-router-dom';
const Sidebar = (props) => {
  //State
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [report, setReport] = useState(false);

  const handleToggle = () => setDropdownOpen(!dropdownOpen);
  const handleReportToogle = () => setReport(!report);

  //Did Mount
  let location = useLocation();
  useEffect(() => {
    let currentMenuToActive = window.location.pathname.split('/')[1] || '/';
    setActiveMenu(currentMenuToActive);
  }, [location]);

  return (
    <div className="side-bar pt-3">
      <ul>
        <NavItem className={activeMenu === 'dashboard' ? 'active' : ''}>
          <Link to={DASHBOARD_PATH}>
            <NavLink>
              <i className="fas fa-tachometer-alt"></i> Dashboard
            </NavLink>
          </Link>
        </NavItem>
        <NavItem className={activeMenu === 'users' ? 'active' : ''}>
          <Link to={USERS_ROUTE_PATH}>
            <NavLink>
              <i className="fas fa-user-friends"></i> Users
            </NavLink>
          </Link>
        </NavItem>
        <NavItem
          className={
            ['customers', 'customerdetails'].includes(activeMenu)
              ? 'active'
              : ''
          }
        >
          <Link to={CUSTOMERS_ROUTE_PATH}>
            <NavLink>
              <i className="fas fa-users" /> Customers
            </NavLink>
          </Link>
        </NavItem>
        <NavItem
          className={
            ['documents', 'create-document', 'edit-document'].includes(
              activeMenu
            )
              ? 'active'
              : ''
          }
        >
          <Link to={DOCUMENTS_PATH}>
            <NavLink>
              <i className="fas fa-file"></i> Documents
            </NavLink>
          </Link>
        </NavItem>

        <NavItem onClick={handleReportToogle}>
          <Link to={AGENCY_REPORT_PAGE}>
            <NavLink>
              <i className="far fa-id-badge"></i>Reports
              <i className="fas fa-sort-down f-right" />
            </NavLink>
          </Link>
        </NavItem>

        {report && (
          <div className="submenu">
            <NavItem className={activeMenu === 'report' ? 'active' : ''}>
              <Link to={AGENCY_REPORT_PAGE}>
                <NavLink>
                  <i className="fas fa-file-invoice-dollar"></i>Web FORM
                </NavLink>
              </Link>
            </NavItem>
          </div>
        )}

        <NavItem className={activeMenu === 'requests' ? 'active' : ''}>
          <Link to={REQUESTS_PATH}>
            <NavLink>
              <i className="far fa-id-badge"></i> Service Requests
            </NavLink>
          </Link>
        </NavItem>

        <NavItem onClick={handleToggle}>
          <Link to={AGENCY_INVOICE_PAGE}>
            <NavLink>
              <i className="fas fa-file-invoice-dollar" />
              Invoice <i className="fas fa-sort-down f-right" />
            </NavLink>
          </Link>
        </NavItem>

        {dropdownOpen && (
          <div className="submenu">
            <NavItem className={activeMenu === 'invoice' ? 'active' : ''}>
              <Link to={AGENCY_INVOICE_PAGE}>
                <NavLink>
                  <i className="fas fa-file-invoice-dollar"></i>All Invoice
                </NavLink>
              </Link>
            </NavItem>
            <NavItem className={activeMenu === 'new-invoice' ? 'active' : ''}>
              <Link to={AGENCY_NEWINVOICE_PAGE}>
                <NavLink>
                  <i className="fas fa-dollar-sign"></i>New Invoice
                </NavLink>
              </Link>
            </NavItem>

            <NavItem className={activeMenu === 'customer' ? 'active' : ''}>
              <Link to={AGENCY_CUSTOMER_PAGE}>
                <NavLink>
                  <i className="fas fa-envelope"></i>Customer
                </NavLink>
              </Link>
            </NavItem>

            <NavItem className={activeMenu === 'subscriptions' ? 'active' : ''}>
              <Link to={AGENCY_SUBSCRIPTIONS_PAGE}>
                <NavLink>
                  <i className="fas fa-shopping-basket"></i>Subscriptions
                </NavLink>
              </Link>
            </NavItem>

            <NavItem className={activeMenu === 'coupons' ? 'active' : ''}>
              <Link to={AGENCY_COUPONS_PAGE}>
                <NavLink>
                  <i className="fas fa-gift"></i>Coupons
                </NavLink>
              </Link>
            </NavItem>
          </div>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
